module.exports = __webpack_public_path__ + "img/image.225e95f9.svg";